// Application-specific utilities
// ------------------------------

// Delegate to Chaplin’s utils module
var utils = Chaplin.utils.beget(Chaplin.utils);

// Add additional application-specific properties and methods
_.extend(utils, {
  initialize: function(options){
    options = (options || {});
    this.options = _.defaults(options,{
      courseUrl: ""
    });
  },
  redirectToPage: function (page) {
    Chaplin.utils.redirectTo({ url: page.path() });
  },
  redirectToModule: function (module) {
    Chaplin.utils.redirectTo({ url: module.get('key') });
  },
  tryRequire: function(path){
    try {
      return require(path);
    } catch (e) {
      if (EF.options.local){
        //console.trace();
        if (e.message.indexOf('Cannot find module') === -1){
          console.error(`Can't load ${path}: ${e.message}`);
        } else {
          console.log(`Can't load ${path}, but that's probably OK`);
        }
      }
      return undefined;
    }
  },
  dotStringToObject: function(dotNotation, object) {
    return dotNotation.split('.').reduce((obj, i) => {
      if(obj) return obj[i];
    }, object);
  },
  coursePath: function(path){
    if (path.substring(0, 4) === 'http' || path.substring(0, 2) ==='//') {
      return path;
    } else if (path.substring(0, 1) === '/'){
      path = path.substring(1, path.length);
    }
    var LocaleService = require('services/locale-service');
    path = path.replace("{{lang}}", LocaleService.getLanguage());
    return (this.options ? this.options.courseUrl : '') + path;
  },

  // Cache bust a path. Assumes path has no parameters.
  bust: function(path){
    return `${path}?_=${Date.now()}`;
  },
  renderMarkdown(value) {
    return marked(value);
  },
  slugify(text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  },
  treatAsUTC(date){
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  },
  daysFromToday(startDate){
    if(startDate.includes('-')) {
      startDate = startDate.split('-').join('/');
    }
    return this.daysDiff(startDate, new Date());
  },
  daysDiff(startDate, endDate) {
    startDate = startDate instanceof Date ? startDate : new Date(startDate);
    endDate = endDate instanceof Date ? endDate : new Date(endDate);

    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
  },
  sanifyJsonApiObject(insaneObject, includes){
    if (!insaneObject){
      return;
    }
    if (Array.isArray(insaneObject)){
      return insaneObject.map((obj) => this.sanifyJsonApiObject(obj, includes));
    }
    if (!insaneObject.attributes && includes){
      let includedObject = includes.find((incl) => {
        return incl.id === insaneObject.id && incl.type === insaneObject.type;
      });
      if (!includedObject) {
        return insaneObject;
      } else {
        insaneObject = includedObject;
      }
    }
    let saneObject = Object.assign({}, insaneObject, insaneObject.attributes);
    delete saneObject.attributes;
    if (saneObject.relationships){
      Object.entries(saneObject.relationships).forEach(([ key, value ]) => {
        if (value.data) {
          if (Array.isArray(value.data)) {
            saneObject[key] = [];
            value.data.forEach((val) => saneObject[key].push(this.sanifyJsonApiObject(val, includes)));
          } else {
            saneObject[key] = this.sanifyJsonApiObject(value.data, includes);
          }
        }
      });
      delete saneObject.relationships;
    }
    return saneObject;
  },
  failProofPromise(promise, failResult = {}){
    return promise.then(data => data, () => $.Deferred().resolve(failResult).promise());
  }
});

module.exports = utils;
